import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlCdFieldsFragment = { id: string, registeredAbroad: boolean, invited: boolean, identityId: string, functions: Array<any>, companyId: string, createdAt: string, updatedAt: string };

export const CdFieldsFragmentDoc = gql`
    fragment CdFields on CompanyDirector {
  id
  registeredAbroad
  invited
  identityId
  functions
  companyId
  createdAt
  updatedAt
}
    `;